import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Input, ElementRef, Output, EventEmitter, OnChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap';

import { Observable } from "rxjs";
import { DemoService } from 'src/app/demo.service';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';

@Component({
  selector: 'app-app-route-helper',
  templateUrl: './app-route-helper.component.html',
  styleUrls: ['./app-route-helper.component.scss'],
  providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}],

})
export class AppRouteHelperComponent implements OnInit {

  location: Location;

  @Output('toggleShow') toggleShow: EventEmitter<any> = new EventEmitter();
  
  @Input() brand_id: number;
  @Input() title: string = 'Upload or Select File';
// as a model vars
  @Input() item_id: number;
  @Input()  closeBtnName: string;
  @Input() list: any[] = [];
  @Input() user_id: number;
  @Input() promotion_id: number;
  @Input() current_route: any;


       // setup as observable?
      //  @Input() item_id?: Observable<any[]>; // impliments on changes.
       @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
       @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
       @Input() item_user_level_id? = '5'; // default to agent just in case
       @Input() item_brand_type_id? = '';
       @Input() show_buttons? = 'no'; // yes | no
       @Input() widget_title? = '';
       @Input() widget_size? = 'full'; // 

       @Input() varible_code_block_type_id? = ''; // Sets what content to show. default is PDF Vars / labels.
       @Input() template_model?: any; // send the subject communication model to set the search paremers for the variable code block grids choosers.
  nav: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: any;
  

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public gfunc: GlobalFunctionsService,
     private modalService: BsModalService,
  ) {
    this.nav = document.querySelector('nav.navbar');


    // login vars
    // Set and Access login Session Variables
    this.gfunc.setLoginSessionVars(); // set in a global function file
    this.sessionUserId = this.gfunc.currentUserVAR.user_id;
    this.sessionUsername = this.gfunc.currentUserVAR.username;
    this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

    // need to add this as routes does not work globally
    this.all_router_details = this.router.url;
    this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

    // Location
    this.location = location;

   }

  ngOnInit(): void {
  }

}
